import { ElementRef } from "@angular/core";
import { IValidationRule } from "./IValidationRule";
import { IValidationRuleController } from "./IValidationRuleController";
import { IValidationRuleEvent } from "./IValidationRuleEvent";
import { IValidationScope } from "./IValidationScope";
export class ValidationRuleController implements IValidationRuleController {
    name: string;
    rules: IValidationRule[] = [];

    get isWarning(): boolean {
        if (this.scopeAccessor().contextAccessor().isWarning) {
            return true;
        }
        return this.rules.every(x => x.isWarning);
    }

    constructor(name: string, ctx: () => IValidationScope) {
        this.scopeAccessor = ctx;
        this.name = name;
    }

    validateValue = (oldValue: any, newValue: any, caller?: ElementRef): boolean => {

        const validationResult = !this.rules.some(r => !r.validate(newValue, oldValue, false, caller));

        // om explicit validering på regel -> publicera till evetuella subscribers att regel är körd.
        if (this.rules.some(x => x.settings.publish)) {
            this.publishToSubscribers({ rule: this.name,
                value: null });
        }

        return validationResult;
    };

    validate = (id?: any): boolean => {
        const rules = this.rule(id);
        rules.forEach(x => {
            x.validateModel();
            x.validateView();
        });
        // om explicit validering på regel som inte är bunden till en vy (viewController) publicerar den att regel är körd.
        if (rules.some(x => x.settings.publish && x.viewController == null)) {
            this.publish({ rule: this.name,
                value: null });
        }

        return !rules.some(r => r.hasError);
    };

    rule = (id: string): IValidationRule[] => this.rules.filter(x => x.settings.id === id);

    private readonly publish = (event: IValidationRuleEvent): void => {
        setTimeout(() => {
            const subscribingRules = this.scopeAccessor().rules.filter(x => x.subscribesTo(event.rule));
            subscribingRules.forEach(x => x.validateView());
        }, 0);
    };

    private readonly publishToSubscribers = (event: IValidationRuleEvent): void => {
        setTimeout(() => {
            const subscribingRules = this.scopeAccessor().rules.filter(x => x.subscribesTo(event.rule));
            subscribingRules.forEach(x => x.validateModel());
        }, 0);
    };

    private readonly scopeAccessor = (): IValidationScope => {
        throw new Error("contextAccessor is undefined");
    };
}
